// Copyright (c) 2016 Deere & Company

import Customer, {getDefaultState} from '../state/customer';
import actions from '../../actions-list';

const updateCustomer = (state, action) =>
    Customer.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_CUSTOMER_SUCCESS]: updateCustomer,
        [actions.RESET_PIP_CODE_REQUEST_CUSTOMER_STATE]: updateCustomer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-code/reducers/customer.js